import { useEffect, useState } from "react";
import { chartColors } from "../utils/constant";
import { OrderV2 } from "../v2/queries/interfacesV2";

export const colors = [...chartColors, ...chartColors, ...chartColors];

const useUniqueOrderColors = (orders: OrderV2[]) => {
  const [orderColor, setOrderColor] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    if (orders?.length > 0) {
      const retVal = {};
      orders.forEach((order, index) => {
        const id = order.order_information.item_id;
        retVal[id] = orderColor[id] || colors[index];
      });
      setOrderColor(retVal);
    } else {
      setOrderColor({});
    }
  }, [orders]);

  return orderColor;
};

export default useUniqueOrderColors;
